export default __webpack_public_path__ + "static/media/5_5.f951abca.jpg";